<div class="container marginMobile">
  <div class="col-sm-12 breadcrumb py-3 m-0">
    <a [routerLink]="['/marques']">Marques</a>&nbsp;>&nbsp;<a href="#">{{brand}}</a>
  </div>
</div>
<div class="container">
      <!-- sideBar -->
      <div class="row">
        <div class="col-12 filterBtn  text-center">
            <button type="button" class="filterMobile closeFilter" name="button" onclick="showFiltre()">Fermer le filtre <i class="fa fa-times" aria-hidden="true"></i>
          </button>
            <button type="button" class="filterMobile openFilter" name="button" onclick="showFiltre()">Filtrer <i class="fa fa-filter" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col-12 col-md-4 col-xl-3 sideFiltre" id="sideFiltre">
          <button class="btn btn-primary titreSideBar brandcollapse" type="button" data-bs-toggle="collapse" data-bs-target="#fournisseur" aria-expanded="false" aria-controls="collapseExample">
              Catégorie <i class="fa fa-chevron-right fa-rotate-90 categoryIcon" aria-hidden="true"></i>
          </button>
          <div class="collapse show" id="fournisseur">
            <div class="f3">
              <div class="list-group">
                <div class="custom-control custom-checkbox p-2" *ngFor="let categorie of categories" >
                    <input type="checkbox" class="custom-control-input " id="defaultUnchecked" [checked]="idsCategories.includes(categorie.id)" (change)="filtrebyCategories(categorie.id,$event)">
                    <label class="custom-control-label ml-2" style="margin-left: 10px;" for="defaultUnchecked">{{categorie.titre}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-8 col-xl-9">
          <div class="container">
            <div class="row">
              <div class="col-sm-12 triProducts mb-4 text-end">
                <div class="triAffichage">
                  Affichage :
                  <select class="form-select selectAffichage" (change)="changeMax($event.target.value)" aria-label="Default select example">
                    <option value="12">x 12 Produits</option>
                    <option value="22">x 22 Produits</option>
                    <option value="44">x 44 Produits</option>
                    <option value="88">x 88 Produits</option>
                  </select>
                </div>
              </div>
              <div class="flash text-center" *ngIf="!products">
                <img src="assets/front/images/logo.png"/>
              </div>
              <div class="col-6 col-md-6 col-lg-4" *ngFor="let product of products | paginate: {itemsPerPage: pageSize,currentPage: page,totalItems: total }">
                <app-card-product [product]="product" ></app-card-product>
              </div>


              <pagination-controls 
                class="text-center" 
                (pageChange)="onPageChange($event)"
                [maxSize]="10"
                [directionLinks]="true"
                [autoHide]="false">
              </pagination-controls>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin sideBar -->
      </div>
